module.exports = __webpack_public_path__ + "img/Doelgroep eerste stuk.0f63706f.webp";